var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"padless":""}},[_c('v-card',{staticClass:"flex",attrs:{"id":"footer","tile":""}},[_c('v-card-text',{staticClass:"d-flex align-center justify-center"},[_c('img',{attrs:{"id":"TempoOne","src":require("../assets/images/tempo.png"),"alt":"logoTempoOne"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }